import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'angular-toastify';
import { ApiService } from 'src/app/api/api.service';
import { CoreService } from 'src/app/services/core-service/core-service.service';
import { parseError } from 'src/app/shared/interfaces';
import Swal from 'sweetalert2';
export interface ExtensionPorPais {
    pais: string;
    extension: string;
}
@Component({
    selector: 'modal-votar',
    templateUrl: './modal-votar.component.html',
    styleUrl: './modal-votar.component.scss'
})
export class ModalVotarComponent implements AfterViewInit {
    @Input() perfilId: number | any = 0;
    @Output() actualizar: EventEmitter<boolean> = new EventEmitter<boolean>;
    private _ingresoCodigo: boolean = false;
    public visible = false;

    formularioVerificacion = new FormGroup({
        codigo: new FormControl(null, Validators.required),
        perfilId: new FormControl(null, Validators.required),
        pais: new FormControl(''),
        telefono: new FormControl('')
    })

    formulario = new FormGroup({
        perfilId: new FormControl(0),
        codigoPais: new FormControl('+502', Validators.required),
        numero: new FormControl(null, Validators.required),
        verificacion: new FormControl(false, Validators.required)
    })

    constructor(
        private core: CoreService,
        private ntf: ToastService,
        private api: ApiService
    ) {

    }

    ngAfterViewInit(): void {
        this.formularioVerificacion.patchValue({ perfilId: this.perfilId })
    }

    toggleLiveDemo() {
        this.visible = !this.visible;
    }

    handleLiveDemoChange(event: any) {
        this.visible = event;
    }

    async votar() {
        try {
            this.core.lock();
            this.formulario.patchValue({ perfilId: this.perfilId })
            await this.api.consulta('nominacion/token', false, [], this.formulario.getRawValue(), 'POST')
            this._ingresoCodigo = true;
        } catch (e) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: `Error: ${parseError(e)}`,
                showConfirmButton: false,
                timer: 1500
            });
        } finally {
            this.core.unlock();
        }
    }

    async validarCodigo() {
        try {
            this.core.lock();
            this.formularioVerificacion.patchValue({ perfilId: this.perfilId, pais: this.formulario.value.codigoPais, telefono: this.formulario.value.numero })
            await this.api.consulta('nominacion/token/verificacion', false, [], this.formularioVerificacion.getRawValue(), 'POST')
            this.ntf.success('Se valido el codigo.')
            this.actualizar.next(true);
            this.visible = false;
            this._ingresoCodigo = false;
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Se agrego el voto.",
                showConfirmButton: false,
                timer: 1500
            });
        } catch (e) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: `Error: ${parseError(e)}`,
                showConfirmButton: false,
                timer: 1500
            });
        } finally {
            this.core.unlock();
        }
    }

    get ingresoCodigo(): boolean {
        return this._ingresoCodigo;
    }

    get extensionesPorPais(): ExtensionPorPais[] {
        return this._extensionesPorPais;
    }

    private _extensionesPorPais: ExtensionPorPais[] = [
        { pais: "Afganistán", extension: "+93" },
        { pais: "Albania", extension: "+355" },
        { pais: "Alemania", extension: "+49" },
        { pais: "Andorra", extension: "+376" },
        { pais: "Angola", extension: "+244" },
        { pais: "Antigua y Barbuda", extension: "+1-268" },
        { pais: "Arabia Saudita", extension: "+966" },
        { pais: "Argelia", extension: "+213" },
        { pais: "Argentina", extension: "+54" },
        { pais: "Armenia", extension: "+374" },
        { pais: "Australia", extension: "+61" },
        { pais: "Austria", extension: "+43" },
        { pais: "Azerbaiyán", extension: "+994" },
        { pais: "Bahamas", extension: "+1-242" },
        { pais: "Bangladés", extension: "+880" },
        { pais: "Barbados", extension: "+1-246" },
        { pais: "Baréin", extension: "+973" },
        { pais: "Bélgica", extension: "+32" },
        { pais: "Belice", extension: "+501" },
        { pais: "Benín", extension: "+229" },
        { pais: "Bielorrusia", extension: "+375" },
        { pais: "Bolivia", extension: "+591" },
        { pais: "Bosnia y Herzegovina", extension: "+387" },
        { pais: "Botsuana", extension: "+267" },
        { pais: "Brasil", extension: "+55" },
        { pais: "Brunéi", extension: "+673" },
        { pais: "Bulgaria", extension: "+359" },
        { pais: "Burkina Faso", extension: "+226" },
        { pais: "Burundi", extension: "+257" },
        { pais: "Bután", extension: "+975" },
        { pais: "Cabo Verde", extension: "+238" },
        { pais: "Camboya", extension: "+855" },
        { pais: "Camerún", extension: "+237" },
        { pais: "Canadá", extension: "+1" },
        { pais: "Catar", extension: "+974" },
        { pais: "Chad", extension: "+235" },
        { pais: "Chile", extension: "+56" },
        { pais: "China", extension: "+86" },
        { pais: "Chipre", extension: "+357" },
        { pais: "Colombia", extension: "+57" },
        { pais: "Comoras", extension: "+269" },
        { pais: "Corea del Norte", extension: "+850" },
        { pais: "Corea del Sur", extension: "+82" },
        { pais: "Costa de Marfil", extension: "+225" },
        { pais: "Costa Rica", extension: "+506" },
        { pais: "Croacia", extension: "+385" },
        { pais: "Cuba", extension: "+53" },
        { pais: "Dinamarca", extension: "+45" },
        { pais: "Dominica", extension: "+1-767" },
        { pais: "Ecuador", extension: "+593" },
        { pais: "Egipto", extension: "+20" },
        { pais: "El Salvador", extension: "+503" },
        { pais: "Emiratos Árabes Unidos", extension: "+971" },
        { pais: "Eritrea", extension: "+291" },
        { pais: "Eslovaquia", extension: "+421" },
        { pais: "Eslovenia", extension: "+386" },
        { pais: "España", extension: "+34" },
        { pais: "Estados Unidos", extension: "+1" },
        { pais: "Estonia", extension: "+372" },
        { pais: "Etiopía", extension: "+251" },
        { pais: "Filipinas", extension: "+63" },
        { pais: "Finlandia", extension: "+358" },
        { pais: "Fiyi", extension: "+679" },
        { pais: "Francia", extension: "+33" },
        { pais: "Gabón", extension: "+241" },
        { pais: "Gambia", extension: "+220" },
        { pais: "Georgia", extension: "+995" },
        { pais: "Ghana", extension: "+233" },
        { pais: "Granada", extension: "+1-473" },
        { pais: "Grecia", extension: "+30" },
        { pais: "Guatemala", extension: "+502" },
        { pais: "Guinea", extension: "+224" },
        { pais: "Guinea Ecuatorial", extension: "+240" },
        { pais: "Guinea-Bisáu", extension: "+245" },
        { pais: "Guyana", extension: "+592" },
        { pais: "Haití", extension: "+509" },
        { pais: "Honduras", extension: "+504" },
        { pais: "Hungría", extension: "+36" },
        { pais: "India", extension: "+91" },
        { pais: "Indonesia", extension: "+62" },
        { pais: "Irak", extension: "+964" },
        { pais: "Irán", extension: "+98" },
        { pais: "Irlanda", extension: "+353" },
        { pais: "Islandia", extension: "+354" },
        { pais: "Islas Marshall", extension: "+692" },
        { pais: "Islas Salomón", extension: "+677" },
        { pais: "Israel", extension: "+972" },
        { pais: "Italia", extension: "+39" },
        { pais: "Jamaica", extension: "+1-876" },
        { pais: "Japón", extension: "+81" },
        { pais: "Jordania", extension: "+962" },
        { pais: "Kazajistán", extension: "+7" },
        { pais: "Kenia", extension: "+254" },
        { pais: "Kirguistán", extension: "+996" },
        { pais: "Kiribati", extension: "+686" },
        { pais: "Kuwait", extension: "+965" },
        { pais: "Laos", extension: "+856" },
        { pais: "Lesoto", extension: "+266" },
        { pais: "Letonia", extension: "+371" },
        { pais: "Líbano", extension: "+961" },
        { pais: "Liberia", extension: "+231" },
        { pais: "Libia", extension: "+218" },
        { pais: "Liechtenstein", extension: "+423" },
        { pais: "Lituania", extension: "+370" },
        { pais: "Luxemburgo", extension: "+352" },
        { pais: "Madagascar", extension: "+261" },
        { pais: "Malasia", extension: "+60" },
        { pais: "Malaui", extension: "+265" },
        { pais: "Maldivas", extension: "+960" },
        { pais: "Malí", extension: "+223" },
        { pais: "Malta", extension: "+356" },
        { pais: "Marruecos", extension: "+212" },
        { pais: "Mauricio", extension: "+230" },
        { pais: "Mauritania", extension: "+222" },
        { pais: "México", extension: "+52" },
        { pais: "Micronesia", extension: "+691" },
        { pais: "Moldavia", extension: "+373" },
        { pais: "Mónaco", extension: "+377" },
        { pais: "Mongolia", extension: "+976" },
        { pais: "Montenegro", extension: "+382" },
        { pais: "Mozambique", extension: "+258" },
        { pais: "Namibia", extension: "+264" },
        { pais: "Nauru", extension: "+674" },
        { pais: "Nepal", extension: "+977" },
        { pais: "Nicaragua", extension: "+505" },
        { pais: "Níger", extension: "+227" },
        { pais: "Nigeria", extension: "+234" },
        { pais: "Noruega", extension: "+47" },
        { pais: "Nueva Zelanda", extension: "+64" },
        { pais: "Omán", extension: "+968" },
        { pais: "Países Bajos", extension: "+31" },
        { pais: "Pakistán", extension: "+92" },
        { pais: "Palaos", extension: "+680" },
        { pais: "Panamá", extension: "+507" },
        { pais: "Papúa Nueva Guinea", extension: "+675" },
        { pais: "Paraguay", extension: "+595" },
        { pais: "Perú", extension: "+51" },
        { pais: "Polonia", extension: "+48" },
        { pais: "Portugal", extension: "+351" },
        { pais: "Reino Unido", extension: "+44" },
        { pais: "República Centroafricana", extension: "+236" },
        { pais: "República Checa", extension: "+420" },
        { pais: "República del Congo", extension: "+242" },
        { pais: "República Democrática del Congo", extension: "+243" },
        { pais: "República Dominicana", extension: "+1-809, +1-829, +1-849" },
        { pais: "Ruanda", extension: "+250" },
        { pais: "Rumania", extension: "+40" },
        { pais: "Rusia", extension: "+7" },
        { pais: "Samoa", extension: "+685" },
        { pais: "San Cristóbal y Nieves", extension: "+1-869" },
        { pais: "San Marino", extension: "+378" },
        { pais: "San Vicente y las Granadinas", extension: "+1-784" },
        { pais: "Santa Lucía", extension: "+1-758" },
        { pais: "Santo Tomé y Príncipe", extension: "+239" },
        { pais: "Senegal", extension: "+221" },
        { pais: "Serbia", extension: "+381" },
        { pais: "Seychelles", extension: "+248" },
        { pais: "Sierra Leona", extension: "+232" },
        { pais: "Singapur", extension: "+65" },
        { pais: "Siria", extension: "+963" },
        { pais: "Somalia", extension: "+252" },
        { pais: "Sri Lanka", extension: "+94" },
        { pais: "Suazilandia", extension: "+268" },
        { pais: "Sudáfrica", extension: "+27" },
        { pais: "Sudán", extension: "+249" },
        { pais: "Sudán del Sur", extension: "+211" },
        { pais: "Suecia", extension: "+46" },
        { pais: "Suiza", extension: "+41" },
        { pais: "Surinam", extension: "+597" },
        { pais: "Tailandia", extension: "+66" },
        { pais: "Tanzania", extension: "+255" },
        { pais: "Tayikistán", extension: "+992" },
        { pais: "Timor Oriental", extension: "+670" },
        { pais: "Togo", extension: "+228" },
        { pais: "Tonga", extension: "+676" },
        { pais: "Trinidad y Tobago", extension: "+1-868" },
        { pais: "Túnez", extension: "+216" },
        { pais: "Turkmenistán", extension: "+993" },
        { pais: "Turquía", extension: "+90" },
        { pais: "Tuvalu", extension: "+688" },
        { pais: "Ucrania", extension: "+380" },
        { pais: "Uganda", extension: "+256" },
        { pais: "Uruguay", extension: "+598" },
        { pais: "Uzbekistán", extension: "+998" },
        { pais: "Vanuatu", extension: "+678" },
        { pais: "Vaticano", extension: "+379" },
        { pais: "Venezuela", extension: "+58" },
        { pais: "Vietnam", extension: "+84" },
        { pais: "Yemen", extension: "+967" },
        { pais: "Yibuti", extension: "+253" },
        { pais: "Zambia", extension: "+260" },
        { pais: "Zimbabue", extension: "+263" },
        { pais: "Taiwan", extension: "+886" },
        { pais: "Hong Kong", extension: "+852" }
    ];
}